import gql from "graphql-tag";

export default gql`
  query {
    instIDs(last: 1) {
      instID
    }
  }
`;
